export enum ActionTypeKeys {
    CHANGE_AGENT_STEP = 'UI_CHANGE_AGENT_STEP',
    CHANGE_TECHNICIAN_STEP = 'UI_CHANGE_TECHNICIAN_STEP',
    CHANGE_FACTORY_STEP = 'UI_CHANGE_FACTORY_STEP',
    CHANGE_INSPECTION_STEP = 'UI_CHANGE_INSPECTION_STEP',
    CHANGE_SERVICE_CALL_TAB = 'UI_CHANGE_SERVICE_CALL_TAB',
}